<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt height="26"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="22"/>
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.svg" alt height="26"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="20"/>
            </span>
          </router-link>
        </div>
        <button
            id="toggle"
            type="button"
            class="btn btn-sm me-2 font-size-16 d-lg-none header-item"
            @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

      </div>

      <div class="d-flex">

        <b-dropdown variant="white" right toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16"/>
            {{ text }}
          </template>
          <b-dropdown-item
              class="notify-item"
              v-for="(entry, i) in languages"
              :key="`Lang${i}`"
              :value="entry"
              @click="setLanguage(entry.language, entry.title, entry.flag)"
              :class="{ active: current_language === entry.language }"
          >
            <img
                :src="`${entry.flag}`"
                alt="user-image"
                class="me-1"
                height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
              type="button"
              class="btn header-item noti-icon"
              @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <b-dropdown
            menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
            toggle-class="header-item noti-icon"
            variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell " :class="{'bx-tada': hasNotification}"></i>
            <span class="badge bg-danger rounded-pill" v-if="hasNotification">
              {{ notifications.length >= 5 ? '5+' : notifications.length }}
            </span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.notifications.title") }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="javascript:void(0)"
                   class="small"
                   :class="{'clear-disabled': notifications.length < 1}"
                   @click="clearAllNotifications">
                  {{ $t("navbar.notifications.mark_as_read") }}
                </a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <div v-if="hasNotification">
              <a class="text-reset notification-item"
                 v-for="(notification, index) in notifications"
                 :key="index">
                <div class="media">
                  <div class="avatar-xs me-3">
                  <span
                      class="avatar-title rounded-circle font-size-16"
                      :class="`bg-${notificationType[notification.data.type].variant}`"
                  >
                    <i :class="notificationType[notification.data.type].icon"></i>
                  </span>
                  </div>
                  <div class="media-body">
                    <h6 class="mt-0 mb-1">
                      {{ notification.data.title }}
                    </h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">
                        {{ notification.data.message }}
                      </p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ notification.created_at }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <no-notification v-else></no-notification>
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
                class="btn btn-sm btn-link font-size-14 text-center"
                href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              <span @click="$router.push({name:'notifications'})"
                    key="t-view-more">{{ $t('navbar.notifications.all_notifications') }}</span>
            </a>
          </div>
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-avatar
                v-if="$auth.check()"
                size="36px"
                class="header-profile-user"
                :src="$auth.user().avatar"
                variant="light">
            </b-avatar>
            <span v-if="$auth.check()" class="d-none d-xl-inline-block ms-1">{{ $auth.user().name }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>

          <b-dropdown-item to="/profile" tag="span">
            <i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ $t("navbar.menu.profile") }}
          </b-dropdown-item>

          <b-dropdown-item to="/settings" tag="span">
              <i class="bx bx-cog font-size-16 align-middle me-1"></i>
              {{ $t("navbar.menu.settings") }}
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <a @click="$auth.logout()" class="dropdown-item text-danger" style="cursor:pointer;">
            <i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.menu.logout") }}
          </a>
        </b-dropdown>

      </div>
    </div>
  </header>
</template>
<script>
import i18n from "../i18n";

import simplebar from "simplebar-vue";
import {layoutComputed} from "@/state/helpers";
import {notificationMethods} from "@/state/helpers";
import {mapGetters} from "vuex";
import NoNotification from "../views/Notifications/Components/NoNotification";
import NotificationMixin from "../mixins/NotificationMixin";

/**"
 * Horizontal-topbar component
 */
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
    ...mapGetters('notifications', ['notifications']),
    hasNotification() {
      return this.notifications.length > 0
    }
  },
  mixins: [NotificationMixin],
  components: {
    NoNotification,
    simplebar,
  },
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        }
      ],
      current_language: i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    this.getNotifications()
    this.startNotificationListening()
  },
  methods: {
    ...notificationMethods,
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    startNotificationListening() {
      this.$auth.load().then(() => {
        window.Echo.private(`user-${this.$auth.user().id}`).notification((notification) => {
          this.addNotification({notification})
        })
      })
    },
    clearAllNotifications() {
      this.clearNotifications()
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  }
};
</script>
<style scoped>
.clear-disabled {
  pointer-events: none;
  opacity: 0.65;
}
</style>
